import { useState, useEffect } from "react";
import LoginContent from "./LoginContent";
import RegisterContent from "./RegisterContent";

const AuthTabs = () => {

    const [active, setActive] = useState("login");

    // لود اولیه → بررسی localStorage برای otp
    useEffect(() => {
        const otpData = localStorage.getItem("otp");

        if (!otpData) {
            // اگر وجود ندارد → تب پیش‌فرض = ورود
            setActive("login");
            return;
        }

        try {
            const obj = JSON.parse(otpData);

            if (obj.login === true) {
                setActive("login");
            } else if (obj.login === false) {
                setActive("register");
            } else {
                // اگر ساختار اشتباه بود → ورود
                setActive("login");
            }

        } catch (err) {
            // اگر JSON خراب بود → ورود
            setActive("login");
        }
    }, []);

    return (
        <div>
            
            {/* تب‌ها */}
            <div className="flex bg-third/40 border border-third rounded-lg p-1.5 mb-4">
                
                {/* ورود */}
                <button
                    onClick={() => setActive("login")}
                    className={`relative flex-1 text-[13px] font-medium py-2.5 rounded-md transition-colors duration-200 
                        ${active === "login" ? "text-white" : "text-slate-500 hover:text-slate-500"}
                    `}
                >
                    {active === "login" && (
                        <div className="absolute inset-0 bg-primary rounded-md shadow-sm"></div>
                    )}
                    <span className="relative z-10">ورود</span>
                </button>

                {/* ثبت نام */}
                <button
                    onClick={() => setActive("register")}
                    className={`relative flex-1 text-[13px] font-medium py-2.5 rounded-md transition-colors duration-200
                        ${active === "register" ? "text-white" : "text-slate-500 hover:text-slate-500"}
                    `}
                >
                    {active === "register" && (
                        <div className="absolute inset-0 bg-primary rounded-md shadow-sm"></div>
                    )}
                    <span className="relative z-10">ثبت نام</span>
                </button>

            </div>

            {/* محتوای تب‌ها */}
            {active === "login" && <LoginContent setActive={setActive} />}
            {active === "register" && <RegisterContent />}

        </div>
    );

};

export default AuthTabs;